export const messages = {
  en: {
    app: {
      search: {
        title: 'Search Condition',
        appId: 'appId',
        name: 'name',
        securityCode: 'securityCode',
        whileListIp: 'whileListIp',
        blackListIp: 'blackListIp',
        remark: 'remark',
        createTime: 'createTime',
        placeholder: 'Please enter app name'
      },
      list: {
        title: 'app List'
      },
      dialog: {
        addTitle: 'Add App',
        editTitle: 'Edit App',
        delTitle: 'Delete App',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        appId: 'appId',
        name: 'name',
        securityCode: 'securityCode',
        whileListIp: 'whileListIp',
        blackListIp: 'blackListIp',
        remark: 'remark',
        createTime: 'createTime',
      },
      table: {
        appId: 'appId',
        name: 'name',
        securityCode: 'securityCode',
        whileListIp: 'whileListIp',
        blackListIp: 'blackListIp',
        remark: 'remark',
        createTime: 'createTime',
      },
      validate: {
        appId: 'Please enter appId',
        name: 'Please enter name',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add App success'
      },
      edit: {
        success: 'Edit App success'
      },
      delete: {
        success: 'Delete App success',
        confirm: 'Are you sure to delete this app?'
      },
      fetchError: 'Failed to fetch app list'
    }
  },
  zh: {
    app: {
      search: {
        title: '查询条件',
        appId: '应用ID',
        name: '名称',
        securityCode: '签名码',
        whileListIp: '白名单ip',
        blackListIp: '黑名单ip',
        remark: '描述',
        createTime: '创建时间',
        placeholder: '请输入app名称'
      },
      list: {
        title: '应用列表'
      },
      dialog: {
        addTitle: '添加',
        editTitle: '编辑',
        delTitle: '删除',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        appId: '应用ID',
        name: '名称',
        securityCode: '签名码',
        whileListIp: '白名单ip',
        blackListIp: '黑名单ip',
        remark: '描述',
        createTime: '创建时间',
      },
      table: {
        appId: '应用ID',
        name: '名称',
        securityCode: '签名码',
        whileListIp: '白名单ip',
        blackListIp: '黑名单ip',
        remark: '描述',
        createTime: '创建时间',
      },
      validate: {
        appId: '请输入应用ID',
        name: '请输入名称',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加成功'
      },
      edit: {
        success: '编辑成功'
      },
      delete: {
        success: '删除成功',
        confirm: '确认删除该应用吗？'
      },
      fetchError: '获取应用列表失败'
    }
  }
}